import { API_CONTEXT_PATH } from "../config/apiConfig";

export const handleSessionExpiration = () => {
  console.error(
    "Session expired (401 Unauthorized). Redirecting to sign-in page...",
  );

  window.location.href = "/" + API_CONTEXT_PATH + "/oauth2/authorization/okta";
};

export async function securedFetch(url, options = {}) {
  try {
    const response = await fetch(url, options);

    if (response.status === 401) {
      handleSessionExpiration();
      throw new Error("Session Expired");
    }

    if (!response.ok) {
      let errorMessage = `API Error: Status ${response.status} for ${url}`;

      try {
        const errorText = await response.text();
        if (errorText) {
          errorMessage = errorText;
        }
      } catch (e) {
        // ignore and use default message
      }

      throw new Error(errorMessage);
    }

    return response;
  } catch (error) {
    throw error;
  }
}
